export default {
  productCodesResults(currentState, value) {
    const state = currentState;
    state.productCodesResults = Object.assign([], value);
  },
};
